// components/ExportReportsOffcanvas.jsx
import { useState } from "react";
import { Transition, Disclosure } from "@headlessui/react";
// import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";

const ExportReportsOffcanvas = ({ isExportModalOpen, onClose }) => {
  const [reportType, setReportType] = useState("impact");
  const [fileFormats, setFileFormats] = useState([]);

  // Report type options
  const reportOptions = [
    {
      value: "impact",
      label: "Impact Report (performance improvement, milestone achievements)",
    },
    {
      value: "usage",
      label: "Usage Report (hours used, active users, app adoption)",
    },
    {
      value: "full",
      label: "Full Report (includes both impact & usage data)",
    },
  ];


  const scopeDataItems = [
    { title: "School / Entity", content: "Select School / Entity" },
    { title: "Grade Level", content: "Select Grade Level" },
    { title: "Applications", content: "Select Applications" },
    { title: "Date Range", content: "Select Date Range" },
  ];
  // File format options
  const formatOptions = [
    { value: "pdf", label: "PDF (formatted for presentation)" },
    { value: "csv", label: "CSV (raw data for analysis)" },
  ];

  const toggleFileFormat = (format) => {
    setFileFormats((prev) =>
      prev.includes(format)
        ? prev.filter((f) => f !== format)
        : [...prev, format]
    );
  };

  return (
    <Transition show={isExportModalOpen}>
      <div className="fixed inset-0 z-50 flex justify-end">
        {/* Overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={onClose}
        ></div>

        {/* Offcanvas Panel */}
        <div className="relative bg-white w-full max-w-[650px] h-full shadow-lg p-6">
          {/* Header */}
          <div className="flex justify-between items-center  pb-3">
            <h2 className="text-[22px] font-bold text-primary-900">
              Export Reports
            </h2>
            <button
              className="text-gray-500 hover:text-gray-800"
              onClick={onClose}
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div>
            {/* Report Type */}
            <div className="mb-6">
              <h3 className="text-[18px] font-medium text-gray-700 mb-3">
                Report Type Selection
              </h3>
              <div className="space-y-3 border rounded-lg p-4 bg-white shadow-sm">
                {reportOptions.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-center gap-2 py-2 text-gray-500"
                  >
                    <input
                      type="radio"
                      name="reportType"
                      value={option.value}
                      checked={reportType === option.value}
                      onChange={(e) => setReportType(e.target.value)}
                      className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-100"
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>

            {/* File Format */}
            <div className="mb-6">
              <h3 className="text-sm font-medium text-gray-700 mb-3">
                File Format Selection
              </h3>
              <div className="space-y-3 border rounded-lg p-4 bg-white shadow-sm">
                {formatOptions.map((format) => (
                  <label
                    key={format.value}
                    className="flex items-center py-2 gap-2 text-gray-500"
                  >
                    <input
                      type="checkbox"
                      checked={fileFormats.includes(format.value)}
                      onChange={() => toggleFileFormat(format.value)}
                      className="w-4 h-4 rounded border-[#ccc] text-blue-600 focus:ring-0"
                    />
                    {format.label}
                  </label>
                ))}
              </div>
            </div>

            {/* Scope of Data */}
            <div className="mb-6">
              <h3 className="text-[18px] font-medium text-gray-500 mb-3">
                Scope of Data
              </h3>
              <div className="border rounded-[10px]">
                {scopeDataItems.map((item, index) => (
                  <Disclosure key={index}>
                    {({ open }) => (
                      <div className="border  ">
                        <Disclosure.Button className="flex justify-between w-full px-4 py-4 text-left text-gray-700 font-medium  hover:bg-gray-100 rounded-lg">
                          <span>{item.title}</span>
                          <ChevronUpIcon
                            className={`${open ? "transform rotate-180" : ""
                              } w-5 h-5 text-gray-500`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 py-2 text-gray-600 bg-white">
                          {item.content}
                        </Disclosure.Panel>
                      </div>
                    )}
                  </Disclosure>
                ))}
              </div>
            </div>

            {/* Export Button */}
            <button
              className="px-4 w-full h-[60px] py-2 bg-primary-600 flex items-center justify-center gap-4 text-white rounded-[10px] hover:bg-primary-800"
              onClick={() =>
                alert(
                  `Exporting ${reportType} report as: ${fileFormats.join(", ")}`
                )
              }
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
              </svg>


              Export
            </button>
          </div>

          {/* Footer */}
          {/* <div className="mt-6 flex justify-end">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() =>
                alert(
                  `Exporting ${reportType} report as: ${fileFormats.join(", ")}`
                )
              }
            >
              Export
            </button>
          </div> */}
        </div>
      </div>
    </Transition>
  );
};

export default ExportReportsOffcanvas;
